import React from 'react';
import { CatalogDetail } from '../../../apis/detail-catalog';
import styles from '../styles.module.css';

interface SectionDetailsProps {
  section: CatalogDetail['departmentSections'][number];
}

export const SectionDetails: React.FC<SectionDetailsProps> = ({ section }) => {
  return (
    <div className={styles.addressInfo}>
      <div className={styles.addressContent}>
        <h3>{section.name}</h3>
        <p>
          <strong>Endereço:</strong> {section.address}
          {section.complement && `, ${section.complement}`}
        </p>
        <p>
          <strong>Bairro:</strong> {section.district}
        </p>
        <p>
          <strong>Cidade:</strong> {section.city} - {section.state}
        </p>
        <p>
          <strong>CEP:</strong> {section.postalCode}
        </p>
        <p>
          <strong>Horário de Funcionamento:</strong> {section.openingTime}
        </p>
        <p>
          <strong>Departamento:</strong> {section.department.name}
        </p>
      </div>
      {section.mapUrl && (
        <div className={styles.mapContainer}>
          <iframe
            title={`Mapa de localização - ${section.name}`}
            src={section.mapUrl}
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      )}
    </div>
  );
};
